import React from "react";
import { Link } from "react-router-dom"; 
import { FaInstagram } from "react-icons/fa";

const FooterSocialLinks = () => {
  return (
    <footer className="py-8 md:py-20 bg-[#2C3075]">
      <div className=" px-8">
        {/* Top Section */}
        <div className="grid grid-cols-1 md:grid-cols-3 items-center text-white border-b md:border-b border-blue-900 pb-4 gap-6 md:gap-0">
          
          {/* Follow us + icon */}
          <div className="flex flex-col md:flex-row items-center font-garamond-subheading md:text-[30px] text-[32px] font-normal text-[#FFFFFF] leading-tight px-4">
            <span className="md:mr-3">Follow us</span>
            <div className="flex space-x-4 mt-2 md:mt-0">
              <a
                href="https://www.instagram.com/arambhrehab?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                target="_blank"
                rel="noreferrer"
              >
                <FaInstagram className="cursor-pointer hover:scale-110 transition" />
              </a>
            </div>
          </div>

          {/* Copyright */}
          <div className="text-sm text-center font-generalsans-description text-[#FFFFFF] font-normal md:text-[20px] leading-[110%]">
            ©2025 Arambh Rehabilitation Center. All rights reserved
          </div>

          {/* Privacy Policy */}
          <div className="text-sm underline cursor-pointer text-center md:text-right font-generalsans-description text-[#FFFFFF] font-normal md:text-[20px] leading-[110%]">
            Privacy Policy
          </div>
        </div>

        {/* Quick Links */}
        <div className="grid grid-cols-1 md:grid-cols-3 items-center gap-4 mt-4">
          {/* Quick Links heading */}
          <div className="text-center md:text-left">
            <h4 className="font-garamond-subheading md:text-[30px] text-[32px] font-normal text-[#FFFFFF] leading-tight mb-10 px-4">
              Quick Links
            </h4>
          </div>

          {/* Middle links */}
          <div className="flex justify-center font-generalsans-description text-[#FFFFFF] font-normal md:text-[20px] leading-[110%]">
            <ul className="hidden md:flex space-x-8">
              <li className="cursor-pointer hover:underline">
                <Link to="/">Home</Link>
              </li>
              <li className="cursor-pointer hover:underline">
                <Link to="/aboutus">About Us</Link>
              </li>
              <li className="cursor-pointer hover:underline">
                <Link to="/services">Services</Link>
              </li>
            </ul>

            {/* Mobile view */}
            <ul className="flex md:hidden flex-wrap justify-center gap-x-6 gap-y-2">
              <li className="cursor-pointer hover:underline">
                <Link to="/">Home</Link>
              </li>
              <li className="cursor-pointer hover:underline">
                <Link to="aboutus">About Us</Link>
              </li>
              <li className="cursor-pointer hover:underline">
                <Link to="services">Services</Link>
              </li>
              <li className="cursor-pointer hover:underline">
                <Link to="contact">Contact Us</Link>
              </li>
            </ul>
          </div>

          {/* Contact Us desktop */}
          <div className="text-center md:text-right font-generalsans-description text-[#FFFFFF] font-normal md:text-[20px] leading-[110%]">
            <div className="hidden md:block cursor-pointer">
             <Link to="contact">Contact Us</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterSocialLinks;
